import React, { useEffect, useState, useMemo } from "react";
import { Form } from "react-bootstrap";

const RepairOrderDetail = ({ data, checkboxSettingsData }) => {
  const safeParse = (val, fallback = {}) => {
    if (!val) return fallback;
    if (typeof val === "object") return val;
    try {
      return JSON.parse(val);
    } catch {
      return fallback;
    }
  };

  // const reasons = data.ReasonForReshellOrRemake
  //   ? JSON.parse(data.ReasonForReshellOrRemake)
  //   : {};

  // Detect if a string is a JSON object
  const isJsonObjectString = (s) => {
    if (typeof s !== "string") return false;
    try {
      const v = JSON.parse(s);
      return v && typeof v === "object" && !Array.isArray(v);
    } catch {
      return false;
    }
  };

  // If ReasonForRepair is plain text (not JSON), show textarea
  const showRepairAsText = useMemo(() => {
    const val = data.ReasonForRepair;
    if (!val) return false;
    // If it's already an object, it's structured
    if (typeof val === "object") return false;
    // If it's a string but not a JSON object, treat as text
    return !isJsonObjectString(val);
  }, [data.ReasonForRepair]);

  const repairReasons = useMemo(
    () => safeParse(data.ReasonForRepair, {}),
    [data.ReasonForRepair]
  );

  const reshellReasons = useMemo(
    () => safeParse(data.ReasonForReshellOrRemake, {}),
    [data.ReasonForReshellOrRemake]
  );

  const remoteRic = useMemo(
    () => safeParse(data.RemoteRICReceiverReplacementData, null),
    [data.RemoteRICReceiverReplacementData]
  );

  const [checkboxList, setCheckboxList] = useState([]);
  const [checkboxListUpdated, setCheckboxListUpdated] = useState(false);

  // Which checkboxes were checked on the builder page (stored as JSON array)
  const additionalChecked = useMemo(() => {
    if (!data.AdditionalInformationCheckbox) return [];
    try {
      return JSON.parse(data.AdditionalInformationCheckbox) || [];
    } catch {
      return [];
    }
  }, [data.AdditionalInformationCheckbox]);

  // Find the index of "Other" inside the settings-derived list
  const otherIndex = useMemo(() => {
    if (!checkboxListUpdated) return -1;
    return checkboxList.findIndex(
      (label) => label.trim().toLowerCase() === "other"
    );
  }, [checkboxListUpdated, checkboxList]);

  // Only show notes textarea if "Other" exists AND was checked
  const showAdditionalNotes =
    otherIndex > -1 && !!additionalChecked[otherIndex];

  useEffect(() => {
    if (checkboxSettingsData && checkboxSettingsData.includes("{")) {
      //set checkbox list
      let splitCheckboxData = checkboxSettingsData
        .replace("{", "")
        .replace("}", "")
        .split(",");
      splitCheckboxData = splitCheckboxData.map((item) => item.trim());
      setCheckboxList(splitCheckboxData);
      setCheckboxListUpdated(true);
    }
  }, [checkboxSettingsData]);

  // useEffect(() => {
  //   // console.log(reasons);
  // }, [reasons]);

  return (
    <table className="w-100 mt-5">
      <tbody>
        <tr>
          <th>Hearing Aid Model:</th>
          <td>
            <div className="row">
              <div className="col-6">
                <label htmlFor="RightEar">Right Ear</label>
                <Form.Control
                  type="text"
                  name="rightEar"
                  className="me-2"
                  aria-label="rightEar"
                  value={data.RightModelCode}
                  readOnly
                />
              </div>
              <div className="col-6">
                <label htmlFor="LeftEar">Left Ear</label>
                <Form.Control
                  type="text"
                  name="leftEar"
                  className="me-2"
                  aria-label="leftEar"
                  value={data.LeftModelCode}
                  readOnly
                />
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>Hearing Aid S/N:</th>
          <td>
            <div className="row">
              <div className="col-6">
                <label htmlFor="HearingAidRightSerialNumber">Right Ear</label>
                <Form.Control
                  type="text"
                  name="HearingAidRightSerialNumber"
                  className="me-2"
                  aria-label="HearingAidRightSerialNumber"
                  value={data.HearingAidRightSerialNumber}
                  readOnly
                />
              </div>
              <div className="col-6">
                <label htmlFor="HearingAidLeftSerialNumber">Left Ear</label>
                <Form.Control
                  type="text"
                  name="HearingAidLeftSerialNumber"
                  className="me-2"
                  aria-label="HearingAidLeftSerialNumber"
                  value={data.HearingAidLeftSerialNumber}
                  readOnly
                />
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>Custom Earmould/Shell S/N:</th>
          <td>
            <div className="row">
              <div className="col-6">
                <label htmlFor="earmouldShellRight">Right Ear</label>
                <Form.Control
                  type="text"
                  name="earmouldShellRight"
                  className="me-2"
                  aria-label="earmouldShellRight"
                  value={data.RightSerialNumber}
                  readOnly
                />
              </div>
              <div className="col-6">
                <label htmlFor="earmouldShellLeft">Left Ear</label>
                <Form.Control
                  type="text"
                  name="earmouldShellLeft"
                  className="me-2"
                  aria-label="earmouldShellLeft"
                  value={data.LeftSerialNumber}
                  readOnly
                />
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>Accessory item count</th>
          <td>
            <Form.Control
              type="number"
              name="Accessories"
              className="me-2 number-input"
              aria-label="Accessories"
              min="0"
              max="5"
              value={data.AccessoriesCount}
              readOnly
            />
          </td>
        </tr>
        <tr>
          <th>Roger item count</th>
          <td>
            <Form.Control
              type="number"
              name="Roger"
              className="me-2 number-input"
              aria-label="Roger"
              min="0"
              max="5"
              value={data.RogerCount}
              readOnly
            />
          </td>
        </tr>
        <tr>
          <th>Charger item count</th>
          <td>
            <Form.Control
              type="number"
              name="ChargerOptions"
              className="me-2 number-input"
              aria-label="ChargerOptions"
              min="0"
              max="5"
              value={data.ChargerOptionsCount}
              readOnly
            />
          </td>
        </tr>
        {/* <tr>
          <h2>Repair</h2>
        </tr>
        <tr>
          <th>Reason for repair</th>
          <td>
            <textarea
              id="ReasonForRepair"
              name="ReasonForRepair"
              rows="8"
              cols="100"
              value={data.ReasonForRepair}
              readOnly
            ></textarea>
          </td>
        </tr>
        <tr>
          <h2>Reshell or Remake</h2>
        </tr>
        <tr>
          <th>Reason for Reshell or Remake</th>
          <td>
            <div className="row">
              <div className="col-6">
                <div className="row reshell-or-remake-checkboxes">
                  <div className="col-12">
                    <input
                      type="checkbox"
                      id="FitRetention"
                      checked={reasons.FitRetention}
                      readOnly
                    />
                    <label htmlFor="FitRetention">Fit - Retention</label>
                  </div>
                  <div className="col-12">
                    <input
                      type="checkbox"
                      id="FitTight"
                      checked={reasons.FitTight}
                      readOnly
                    />
                    <label htmlFor="FitTight">Fit - Tight</label>
                  </div>
                  <div className="col-12">
                    <input
                      type="checkbox"
                      id="Feedback"
                      checked={reasons.Feedback}
                      readOnly
                    />
                    <label htmlFor="Feedback">Feedback</label>
                  </div>
                  <div className="col-12">
                    <input
                      type="checkbox"
                      id="DifficultyWithInsertion"
                      checked={reasons.DifficultyWithInsertion}
                      readOnly
                    />
                    <label htmlFor="DifficultyWithInsertion">
                      Difficulty with Insertion
                    </label>
                  </div>
                  <div className="col-12">
                    <input
                      type="checkbox"
                      id="CosmeticReasons"
                      checked={reasons.CosmeticReasons}
                      readOnly
                    />
                    <label htmlFor="CosmeticReasons">Cosmetic Reasons</label>
                  </div>
                  <div className="col-12">
                    <input
                      type="checkbox"
                      id="Broken"
                      checked={reasons.Broken}
                      readOnly
                    />
                    <label htmlFor="Broken">Broken</label>
                  </div>
                </div>
              </div>
              <div className="col-6 reshell-or-remake-checkboxes">
                <input
                  type="checkbox"
                  id="CurrentWearer"
                  checked={data.IsCurrentPhonakHearingAidWearer}
                  readOnly
                />
                <label htmlFor="CurrentWearer">
                  Current Phonak Hearing aid Wearer?
                </label>
              </div>
            </div>
          </td>
        </tr> */}
        {/* -------- Repair -------- */}
        {console.log("data order type:", data.OrderType)}
        {(data.OrderType.includes("Repair") || data.OrderType.includes("Repair or Remake")) && (
          <>
            <tr>
              <th colSpan={2}>
                <h2 className="mt-4">Repair</h2>
              </th>
            </tr>

            {showRepairAsText ? (
              <tr>
                <th>Reason for repair</th>
                <td>
                  <textarea
                    id="ReasonForRepair"
                    name="ReasonForRepair"
                    rows={8}
                    cols={100}
                    value={
                      (typeof data.ReasonForRepair === "string"
                        ? data.ReasonForRepair
                        : "") || ""
                    }
                    readOnly
                  />
                </td>
              </tr>
            ) : (
              <tr>
                <th>Reason for repair</th>
                <td>
                  <div className="row">
                    <div className="col-6">
                      <div className="row reshell-or-remake-checkboxes">
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="deviceDead"
                            checked={!!repairReasons.DeviceDead}
                            readOnly
                          />
                          <label htmlFor="deviceDead">Device Dead</label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="notCharging"
                            checked={!!repairReasons.NotCharging}
                            readOnly
                          />
                          <label htmlFor="notCharging">Not Charging</label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="highBatteryDrain"
                            checked={!!repairReasons.HighBatteryDrain}
                            readOnly
                          />
                          <label htmlFor="highBatteryDrain">
                            High Battery Drain
                          </label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="noisyCrackling"
                            checked={!!repairReasons.NoisyCrackling}
                            readOnly
                          />
                          <label htmlFor="noisyCrackling">
                            Noisy: Crackling
                          </label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="noisyStatic"
                            checked={!!repairReasons.NoisyStatic}
                            readOnly
                          />
                          <label htmlFor="noisyStatic">
                            Noisy: Static/Hissing
                          </label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="weakLowOutput"
                            checked={!!repairReasons.WeakOutput}
                            readOnly
                          />
                          <label htmlFor="weakLowOutput">Weak/Low Output</label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="bluetoothConnectivityIssue"
                            checked={!!repairReasons.BluetoothIssue}
                            readOnly
                          />
                          <label htmlFor="bluetoothConnectivityIssue">
                            Bluetooth Connectivity Issue
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="row reshell-or-remake-checkboxes">
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="intermittent"
                            checked={!!repairReasons.Intermittent}
                            readOnly
                          />
                          <label htmlFor="intermittent">Intermittent</label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="distorted"
                            checked={!!repairReasons.Distorted}
                            readOnly
                          />
                          <label htmlFor="distorted">Distorted</label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="damagedHousing"
                            checked={!!repairReasons.DamagedHousing}
                            readOnly
                          />
                          <label htmlFor="damagedHousing">
                            Damaged Housing
                          </label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="damagedRemovalLine"
                            checked={!!repairReasons.DamagedRemovalLine}
                            readOnly
                          />
                          <label htmlFor="damagedRemovalLine">
                            Damaged Removal Line
                          </label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="damagedReceiverWire"
                            checked={!!repairReasons.DamagedReceiverWire}
                            readOnly
                          />
                          <label htmlFor="damagedReceiverWire">
                            Damaged Receiver Wire
                          </label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="cleanFunctionalCheck"
                            checked={!!repairReasons.CleanFunctionalCheck}
                            readOnly
                          />
                          <label htmlFor="cleanFunctionalCheck">
                            Clean &amp; Functional Check
                          </label>
                        </div>

                        {/* Other (manual) */}
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="repairOther"
                            checked={
                              typeof repairReasons.Other === "string"
                                ? repairReasons.Other.trim() !== ""
                                : !!repairReasons.Other
                            }
                            readOnly
                          />
                          <label htmlFor="repairOther">Other</label>
                          {typeof repairReasons.Other === "string" &&
                            repairReasons.Other.trim() !== "" && (
                              <div className="mt-2">
                                <label
                                  htmlFor="repairOtherNotes"
                                  className="sr-only"
                                >
                                  Other details
                                </label>
                                <textarea
                                  id="repairOtherNotes"
                                  rows={3}
                                  className="w-100"
                                  value={repairReasons.Other}
                                  readOnly
                                />
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </>
        )}
        {/* -------- Reshell / Remake -------- */}
        {(data.OrderType.includes("RepairRemake") ||
          data.OrderType.includes("ReshellRemake")) && (
          <>
            <tr>
              <th colSpan={2}>
                <h2 className="mt-4">Reshell or Remake</h2>
              </th>
            </tr>
            <tr>
              <th>Reason for Reshell or Remake</th>
              <td>
                <div className="row">
                  <div className="col-6">
                    <div className="row reshell-or-remake-checkboxes">
                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="FitRetention"
                          checked={!!reshellReasons.FitRetention}
                          readOnly
                        />
                        <label htmlFor="FitRetention">Fit - Retention</label>
                      </div>
                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="FitTight"
                          checked={!!reshellReasons.FitTight}
                          readOnly
                        />
                        <label htmlFor="FitTight">Fit - Tight</label>
                      </div>
                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="Feedback"
                          checked={!!reshellReasons.Feedback}
                          readOnly
                        />
                        <label htmlFor="Feedback">Feedback</label>
                      </div>
                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="DifficultyWithInsertion"
                          checked={!!reshellReasons.DifficultyWithInsertion}
                          readOnly
                        />
                        <label htmlFor="DifficultyWithInsertion">
                          Difficulty with Insertion
                        </label>
                      </div>
                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="CosmeticReasons"
                          checked={!!reshellReasons.CosmeticReasons}
                          readOnly
                        />
                        <label htmlFor="CosmeticReasons">
                          Cosmetic Reasons
                        </label>
                      </div>
                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="Broken"
                          checked={!!reshellReasons.Broken}
                          readOnly
                        />
                        <label htmlFor="Broken">Broken</label>
                      </div>

                      {/* Occlusion */}
                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="Occlusion"
                          checked={!!reshellReasons.Occlusion}
                          readOnly
                        />
                        <label htmlFor="Occlusion">Occlusion</label>
                      </div>

                      {/* Other */}
                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="Other"
                          checked={!!reshellReasons.Other}
                          readOnly
                        />
                        <label htmlFor="Other">Other</label>
                        {typeof reshellReasons.Other === "string" &&
                          reshellReasons.Other.trim() !== "" && (
                            <div className="mb-2">
                              <textarea
                                className="w-100"
                                rows={3}
                                value={reshellReasons.Other}
                                readOnly
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="col-6 reshell-or-remake-checkboxes">
                    <input
                      type="checkbox"
                      id="CurrentWearer"
                      checked={!!data.IsCurrentPhonakHearingAidWearer}
                      readOnly
                    />
                    <label htmlFor="CurrentWearer">
                      Current Phonak Hearing Aid Wearer?
                    </label>
                  </div>
                </div>
              </td>
            </tr>
          </>
        )}
        {/* -------- Remote RIC Receiver Replacement -------- */}
        {data.OrderType.includes("RemoteRicReceiverReplacement") &&
          remoteRic &&
          (remoteRic.Left || remoteRic.Right) && (
            <>
              <tr>
                <th colSpan={2}>
                  <h2 className="mt-4">Remote RIC Receiver Replacement</h2>
                </th>
              </tr>
              <tr>
                <th>Receiver Options</th>
                <td>
                  <div className="row">
                    {remoteRic.Right && (
                      <div className="col-md-6 mb-3">
                        <h5>Right Ear</h5>
                        <Form.Group className="mb-2">
                          <Form.Label>Receiver Length</Form.Label>
                          <Form.Control
                            as="select"
                            value={remoteRic.Right.ReceiverLength || ""}
                            disabled
                          >
                            <option value="">Select…</option>
                            {["00", "0", "1", "2", "3"].map((v) => (
                              <option key={v} value={v}>
                                {v}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group className="mb-2">
                          <Form.Label>Receiver Strength</Form.Label>
                          <Form.Control
                            as="select"
                            value={remoteRic.Right.ReceiverStrength || ""}
                            disabled
                          >
                            <option value="">Select…</option>
                            {["S", "M", "P", "UP"].map((v) => (
                              <option key={v} value={v}>
                                {v}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group>
                          <Form.Label>Generation</Form.Label>
                          <Form.Control
                            as="select"
                            value={remoteRic.Right.Generation || ""}
                            disabled
                          >
                            <option value="">Select…</option>
                            {["5.0", "6.0"].map((v) => (
                              <option key={v} value={v}>
                                {v}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                      </div>
                    )}

                    {remoteRic.Left && (
                      <div className="col-md-6 mb-3">
                        <h5>Left Ear</h5>
                        <Form.Group className="mb-2">
                          <Form.Label>Receiver Length</Form.Label>
                          <Form.Control
                            as="select"
                            value={remoteRic.Left.ReceiverLength || ""}
                            disabled
                          >
                            <option value="">Select…</option>
                            {["0", "1", "2", "3"].map((v) => (
                              <option key={v} value={v}>
                                {v}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group className="mb-2">
                          <Form.Label>Receiver Strength</Form.Label>
                          <Form.Control
                            as="select"
                            value={remoteRic.Left.ReceiverStrength || ""}
                            disabled
                          >
                            <option value="">Select…</option>
                            {["S", "M", "P", "UP"].map((v) => (
                              <option key={v} value={v}>
                                {v}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group>
                          <Form.Label>Generation</Form.Label>
                          <Form.Control
                            as="select"
                            value={remoteRic.Left.Generation || ""}
                            disabled
                          >
                            <option value="">Select…</option>
                            {["5.0", "6.0"].map((v) => (
                              <option key={v} value={v}>
                                {v}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            </>
          )}
        {/* ////////////////////////////////////////////////////////////////////////////////////////// */}
        {/* ////////////////////////////////////CHECKBOX IS SET HERE////////////////////////////////// */}
        {/* ////////////////////////////////////////////////////////////////////////////////////////// */}
        <tr>
          <th>
            Additional Information
            <br />
          </th>
          <td>
            <div className="row">
              <div className="col-6">
                <div className="row reshell-or-remake-checkboxes">
                  {checkboxListUpdated
                    ? checkboxList.map((checkbox, index) => {
                        const checkboxId = checkbox.trim();
                        return (
                          <div
                            className="col-12"
                            key={`${checkboxId}-${index}`}
                          >
                            <input
                              type="checkbox"
                              id={checkboxId}
                              checked={!!additionalChecked[index]}
                              readOnly
                            />
                            <label htmlFor={checkboxId}>{checkbox}</label>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          </td>
        </tr>

        {showAdditionalNotes && (
          <tr>
            <th>Additional Notes</th>
            <td>
              <textarea
                id="AdditionalInformation"
                name="AdditionalInformation"
                rows="8"
                cols="100"
                value={data.AdditionalInformation || ""}
                readOnly
              />
            </td>
          </tr>
        )}
        <tr>
          <th>Quote required for Specific funding type:</th>
          <td>
            <div className="row reshell-or-remake-checkboxes">
              <div className="col-12">
                <input
                  type="checkbox"
                  id="Enable"
                  checked={data.IsEnable}
                  readOnly
                />
                <label htmlFor="Enable">
                  {`Enable (H.Aid is 5+ years old) - Please quote if the repair cost is more than $235 per H.Aid`}
                </label>
              </div>
              <div className="col-12">
                <input
                  type="checkbox"
                  id="VeteransAffairs"
                  checked={data.IsVeteransAffairsClient}
                  readOnly
                />
                <label htmlFor="VeteransAffairs">
                  {`Veterans Affairs (H.Aid is 5+ years old) - Please quote if the repair cost is more than $277 per H.Aid`}
                </label>
              </div>
              <div className="col-12">
                <input
                  type="checkbox"
                  id="Insurance"
                  checked={data.IsInsurance}
                  readOnly
                />
                <label htmlFor="Insurance">
                  Insurance - Please provide a quote before any repair is
                  carried out
                </label>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default RepairOrderDetail;
